import Style from "ol/style/Style";
import Text from "ol/style/Text";
import Stroke from "ol/style/Stroke";
import CircleStyle from "ol/style/Circle.js";
import RegularShape from "ol/style/RegularShape";
import Fill from "ol/style/Fill";
import Icon from "ol/style/Icon";
import { constants } from "./sources";

export const dot_style_anschlusspunkte = new CircleStyle({
  radius: 5,
  fill: new Fill({ color: "white" }),
  stroke: new Stroke({ color: "blue", width: 1 }),
});



export function grobtrasseStyleFunction(feature, resolution, spannung) {
  const spannungsEbene = feature.get("spannungsebene");

  if (spannungsEbene != spannung) { return null; /* Keine Style anwenden, wenn die Spannungsebene nicht übereinstimmt */ }
  let borderColor = spannungsEbene == "110" ? "blue" : spannungsEbene == "220" ? "green" : spannungsEbene == "380" ? "red" : "black";
  let fillColor = spannungsEbene == "110" ? "rgba(0, 0, 255, 0.2)" : spannungsEbene == "220" ? "rgba(0, 255, 0, 0.2)" : spannungsEbene == "380" ? "rgba(255, 0, 0, 0.2)" : "gray";
  
  return new Style({
      stroke: new Stroke({ color: borderColor, width: 1 }),
      fill: new Fill({ color: fillColor }),
  });
}  

const setTextLabel = (feature, resolution) => {
  const name = feature.get("bau_nummer_version");
  if (!name) return null;
  
  return new Text({
    text: name,
    fill: new Fill({ color: "black" }),
    stroke: new Stroke({ color: "white", width: 3 }),
    offsetX: 10,
    offsetY: 0,
    font: "bold 10px Arial",
    placement: "point",
    textBaseline: "bottom",
    textAlign: "left",
  });
}
 

export function mastStandorteStyleFunction(feature, resolution, label) {
  const planungsart = feature.get("planungsart");
  const spannungsEbene = feature.get("spannungsebene");
  const mast_typ = feature.get("mast_typ");

  if (planungsart != "n") { return null; /* Keine Style anwenden, wenn die Planungsart nicht "n" ist */ }
  let fillColor = spannungsEbene == "110" ? "blue" : spannungsEbene == "220" ? "green" : spannungsEbene == "380" ? "red" : "black";

  if (mast_typ == "abspannmast") {
    return new Style({
      image: new RegularShape({
        fill: new Fill({ color: fillColor }),
        stroke: new Stroke({ color: "white", width: 2 }),
        points: 4,
        radius: 8,
        angle: Math.PI / 4,
      }),
      text: label ? setTextLabel(feature, resolution) : null,
    });
  } else if (mast_typ == "tragmast") {
    return new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: fillColor }),
        stroke: new Stroke({ color: "white", width: 2 }),
      }),
      text: label ? setTextLabel(feature, resolution) : null,
    });
  }
}

export function uwStyleFunction(feature, resolution) {
  const spannungsEbene = feature.get("spannungsebene");
  const fillColor = spannungsEbene == "110" ? "blue" : "red";

  if (spannungsEbene == 110) {
    return new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: fillColor }),
        stroke: new Stroke({ color: "black", width: 1 }),
      }),
      zIndex: 120,
    });
  } else {
    return new Style({
      image: new RegularShape({
        fill: new Fill({ color: "red" }),
        stroke: new Stroke({ color: "black", width: 1 }),
        points: 4,
        radius: 12,
        angle: Math.PI / 4,
      }),
      zIndex: 120,
    });
  }
}

export function hinweiseOverviewStyleFunction(feature, resolution) {
  return new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "grafiken/icons/fahne.png",
      scale: 1,
    }),
 });
}



export function hinweiseStyleFunction(feature, resolution) {

    let styles = {
      'Point': new Style({
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({
            color: 'rgba(255, 255, 0, 0.4)',
          }), 
          stroke: new Stroke({
            color: 'magenta', 
            width: 2
          }),
        }),
      }),
      'LineString': new Style({
        stroke: new Stroke({
          color: 'magenta',
          width: 2,
        }),
      }),
      'Polygon': new Style({
        stroke: new Stroke({
          color: 'magenta',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 0, 0.4)',
        }),

      }),
    };
    styles['MultiPoint'] = styles['Point'];
    styles['MultiLineString'] = styles['LineString'];
    styles['MultiPolygon'] = styles['Polygon'];

    return styles[feature.getGeometry().getType()] || null;
  }


export function planungstrasseStyleFunction(feature, resolution, spannung, background = false) {
  const spannungsEbene = feature.get("spannungsebene");
  let color = spannungsEbene == "110" ? "blue" : spannungsEbene == "220" ? "green" : spannungsEbene == "380" ? "red" : "gray";
  
  if (spannung === 'variante') { 
    color = 'magenta';
  } else if (spannungsEbene !== spannung) { return null; /* Keine Style anwenden, wenn die Spannungsebene nicht übereinstimmt */ }
  
  console.log("resolution:", resolution);
  
  let width = 5;
  let lineDash = [10, 5];
  if (resolution < 20) {
    lineDash = [3 * constants.servitutsbreite / resolution, 3 * constants.servitutsbreite / resolution];
    width = constants.servitutsbreite / resolution; 
  }

  if (background) {
    color = "white"; // Hintergrundfarbe für die Linie
    lineDash = []; // Keine Striche für die Hintergrundlinie
  }

  
  let style =new Style({
    stroke: new Stroke({
      color: color,
      width: width,
      lineDash: lineDash,
      lineCap: "butt",
    }),
  });

  return style;
}
